import React from "react";
import { Link } from "react-router-dom";

import { MdOutlineAdminPanelSettings, MdPhoneInTalk } from "react-icons/md";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { useGetBlogsQuery } from "../../products/productSlice";

// import blog1 from "../../../assets/img/serviceList/cagliata.jpg";
// import blog2 from "../../../assets/img/serviceList/Indian-Cereals.jpg";
// import blog3 from "../../../assets/img/serviceList/Indian-Pulses.jpg";
// import blog4 from "../../../assets/img/serviceList/gr5ikknbtygma4krpfai.png";
// import blog5 from "../../../assets/img/serviceList/f454dq2nqgkt45dcladv.png";
// import blog6 from "../../../assets/img/serviceList/jo1im9jkpkbst0of9sti.png";

const newsArray = [
  {
    id: 1,
    date: "02 Apr",
    // url: blog1,
    title:
      "How to Scale Your PCD Pharma Franchise Business: Tips for Long-Term Success",
    desc: "The pharmaceutical industry in India has grown drastically in the recent past, and it is because of the PCD pharma franchise company model. This model has brought about an edge for entrepreneurs interested..",
    link: "Read more",
  },
  {
    id: 2,
    date: "02 Apr",
    // url: blog2,
    category: "Blog",
   
    title: "Benefits of Starting a PCD Pharma Franchise Business in India",
    desc: "The pharmaceutical industry in India has witnessed a fast-paced growth rate. Moreover, the rising demand for quality healthcare has generated many business opportunities for flourishing. Among such an opportunity is PCD pharma franchise in India.",
    link: "Read more",
  },
  {
    id: 3,
    date: "02 Apr",
    // url: blog3,
    category: "Blog",
    title: "PCD Pharma Franchise in India: Strategic Vision for Contemplating the Year 2025?",
    desc: "One of the biggest and most exciting areas for entrepreneurs in India is in the form of Propaganda Cum Distribution franchise or PCD franchise business in the Global Pharma franchise market. For new investors",
    link: "Read more",
  },
  {
    id: 4,
    date: "02 Apr",
    // url: blog4,
   
    title: "How Wholesale Pharmacy Distributors Enhance Healthcare Accessibility in India",
    desc: "One of the biggest and most exciting areas for entrepreneurs in India is in the form of Propaganda Cum Distribution franchise or PCD franchise business in the Global Pharma franchise market. For new investors",
    link: "Read more",
  },
  {
    id: 5,
    date: "02 Apr",
    // url: blog5,
    category: "Blog",
    
    title: "Pharma Franchise",
    desc: "The pharmaceutical industry of India is growing very rapidly especially in regions like Maharashtra because people here are looking out for quality medicines with such an unrelenting and unstoppable demand.",
    link: "Read more",
  },
  
];
function BlogItem() {
  const { data, isLoading } = useGetBlogsQuery();
  return (
    <>
      <section className="blogItemSec">
        <div className="row">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {newsArray.map((item) => {
            return (
              <div key={item.id} className="col-lg-6">
                <div className="blogItemInfo bgGray">
                  <div className="blogItemFigure">
                    {/* <img src={item.url} className="img-fluid" alt="Blog" /> */}
                    <div className="postDate">
                      <span className="date">25</span>
                      <span className="month">feb</span>
                    </div>
                  </div>
                  <div className="blogItemContent">
                    <div className="author">
                      <ul>
                        <li>
                          {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                          <Link to={`/blog-detail/${item.id}`}>
                            <MdOutlineAdminPanelSettings />
                            By Ismail
                          </Link>
                        </li>
                        <li>
                          {/* <Link to={`/blog-detail/${item.uid}/${item.slug}}`}> */}
                          <Link to={`/blog-detail/${item.id}`}>
                            {" "}
                            <MdPhoneInTalk /> Consulting
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="title">
                      <h4>
                        {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                        <Link to={`/blog-detail/${item.id}`}>{item.title}</Link>
                      </h4>
                      <p>{item.desc}</p>
                    </div>
                    <div className="readMore">
                      <Link to={`/blog-detail/${item.id}`}>
                        {/* <Link to={`/blog-detail/${item.uid}/${item.slug}`}> */}
                        Read More <HiOutlineArrowNarrowRight />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {/* {data &&
            data.map((item) => {
              return (
                <div key={item._id} className="col-lg-6">
                  <div className="blogItemInfo">
                    <div className="blogItemFigure">
                      <img
                        src={item.banner.url}
                        style={{ height: "400px" }}
                        alt="Blog"
                      />
                      <div className="postDate">
                        <span className="date">25</span>
                        <span className="month">feb</span>
                      </div>
                    </div>
                    <div className="blogItemContent">
                      <div className="author">
                        <ul>
                          <li>
                            <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                              <MdOutlineAdminPanelSettings />
                              By Ismail
                            </Link>
                          </li>
                          <li>
                            <Link to={`/blog-detail/${item.uid}/${item.slug}}`}>
                              {" "}
                              <MdPhoneInTalk /> Consulting
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="title">
                        <h4>
                          <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                            {item.title}
                          </Link>
                        </h4>
                        <p>{item.short_description}</p>
                      </div>
                      <div className="readMore">
                        <Link to={`/blog-detail/${item.uid}/${item.slug}`}>
                          Read More <HiOutlineArrowNarrowRight />{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })} */}
        </div>
      </section>
    </>
  );
}

export default BlogItem;
